<template>
    <b-overlay :show="loading">
        <div class="d-flex align-items-center pt-2 ml-3 border-bottom pb-2">
            <span>{{ $t('labels.ordercheckout') }}</span>
        </div>
        <div class="d-flex mt-4 w-100">
            <!-- content section -->
            <div class="row m-0 w-100">
                <div v-if="timepass" class="col-12 col-lg-8">
                    <div class="bg-white mh-100 h-100 d-flex flex-column align-items-end">
                        <!-- header -->

                        <!-- body -->
                        <div class="align-self-start w-100 overflow-auto mh-100">
                            <div class="d-flex">
                                <div class="d-flex flex-column">
                                    <h3 class="grey">{{ $t('labels.timepass') }}</h3>
                                    <div class="d-flex">
                                        {{ timepass.Name }}
                                    </div>
                                </div>
                                <div class="ml-auto d-flex">
                                    <div class="d-flex flex-column">
                                        <h3 class="grey">{{ $t('labels.buyPass.paymentDueToday') }}</h3>
                                        <span>
                                            {{ totalPrice() }} {{ timepass.Currency }} /
                                            {{ $tc('units.months', 1) }}
                                        </span>
                                        <small class="grey mt-1">
                                            {{
                                                $t('labels.buyPass.priceIncludesTax', {
                                                    percentage: taxRate.Percentage,
                                                    name: taxRate.DisplayName,
                                                })
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="d-flex flex-column">
                                    <h3 class="grey mt-2">{{ $t('labels.account') }}</h3>
                                    <span>{{ me.Profile.Name }}</span>
                                    <span class="mt-2">{{ me.Email }}</span>
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="d-flex flex-column">
                                    <h3 class="grey">{{ $t('labels.paymentmethod') }}</h3>
                                    <!-- Add current payment method display -->
                                    <span></span>
                                    <span class="mt-1"></span>
                                </div>
                            </div>
                            <div class="d-flex mt-2">
                                <div class="d-flex flex-column">
                                    <span class="m-0 p-0">{{ $t('messages.buyPass.availableImmediately') }}</span>
                                </div>
                            </div>
                            <div v-if="isAdminSpace" class="d-flex mt-4 align-items-center">
                                <div class="d-flex flex-column">
                                    <span>{{ $t('labels.buyPass.overridePrice') }}</span>
                                    <b-form-checkbox v-model="overRide" name="check-button" switch></b-form-checkbox>
                                    <span class="small">{{ $t('messages.buyPass.overrideInfo') }}</span>
                                </div>
                            </div>

                            <div class="d-flex align-items-center mt-4 mb-3" v-if="termsAndConditions">
                                <b-form-checkbox
                                    id="checkbox-2"
                                    name="checkbox-2"
                                    v-model="AcceptTermsAndConditions"
                                    required
                                >
                                </b-form-checkbox>
                                <i18n class="mb-0" path="labels.acceptterms" tag="p">
                                    <template>
                                        <a
                                            class="text-primary mb-0"
                                            @click="$bvModal.show('terms-and-conditions')"
                                            :title="$t('labels.termsandconditions')"
                                            >{{ $t('labels.termsandconditions') }}</a
                                        >
                                    </template>
                                </i18n>
                            </div>
                        </div>
                        <!-- footer -->
                    </div>
                </div>
            </div>
        </div>
        <!-- membership state -->
        <b-modal id="terms-and-conditions" hide-footer :title="$t('labels.termsandconditions')" size="xl">
            <div v-if="termsAndConditions" v-html="termsAndConditions.Content"></div>
        </b-modal>
    </b-overlay>
</template>
<style lang="less" scoped>
.grey {
    color: gray;
}

.small-text {
    font-size: 0.8rem;
}

@media (min-width: 768px) {
    .col-image {
        height: 70vh;
    }

    .column {
        min-height: 70vh;
    }
}
</style>

<script>
export default {
    name: 'BuyPassReview',
    props: ['timepass', 'taxRate', 'isAdminSpace'],
    data() {
        return {
            AcceptTermsAndConditions: false,
            overRide: false,
            loading: false,
            me: this.$store.state.me,
        };
    },
    watch: {
        AcceptTermsAndConditions() {
            this.$emit('isAccepted');
        },
        overRide() {
            this.$emit('priceOverride');
        },
        // If no terms are configured after store load, auto-accept.
        termsAndConditionsLoaded() {
            this.applyTermsAvailability();
        },
    },
    computed: {
        // Read legal agreements from the store (loaded once on app start).
        termsAndConditions() {
            return this.$store.state.termsAndConditions;
        },
        termsAndConditionsLoaded() {
            return this.$store.state.termsAndConditionsLoaded;
        },
        isReady() {
            return this.AcceptTermsAndConditions;
        },
    },
    mounted() {
        this.applyTermsAvailability();
    },
    methods: {
        // Auto-accept terms if the store reports none are configured.
        applyTermsAvailability() {
            if (this.termsAndConditionsLoaded && !this.termsAndConditions) {
                this.AcceptTermsAndConditions = true;
            }
        },
        back() {
            this.$emit('prevStep');
            this.AcceptTermsAndConditions = false;
        },
        buyPass() {
            this.$emit('buyPass');
        },
        calculatePrice(timepass) {
            if (this.taxRate.Inclusive) {
                const price = timepass.PriceInCents / 100.0;
                return price;
            }
            const price = timepass.PriceInCents / 100.0;
            const totalPrice = price * (this.taxRate.Percentage / 100 + 1);
            return totalPrice;
        },
        totalPrice() {
            const total = this.calculatePrice(this.timepass);

            return total.toFixed(2);
        },
    },
};
</script>
